import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadWorkshops } from '../workshops/actions';
import Filter from './Filter';
import { withTranslation } from 'react-i18next';
import List from './List';

class WorkshopsAttendance extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter } = this.props.pagination;
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({ centerId: -1 });
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	render() {
		const { pagination, data, t } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />
				<List
					onFetchData={this.handleListEvent}
					data={data}
					t={t}
					{...pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { workshops }
	} = state;

	const workshopPagination = pagination.workshops.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: workshopPagination.ids.map(id => workshops[id]),
		pagination: workshopPagination
	};
};

const mapDispatchToProps = {
	loadEntities: loadWorkshops,
	initializeFilter: (data, fields) => initialize('workshopAttendanceFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WorkshopsAttendance));